import { useEffect } from "react";

function Redirect() {
  useEffect(() => {
    window.location.href = "https://hazo.ai/home.php";
  });

  return null;
}

export default Redirect;
